export default __webpack_public_path__ + "static/media/home.94e8fc45.svg";